import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { ButtonPrimary } from "../common/ButtonPrimary";
import { RewardItems } from "../items-displayer/RewardItems";
import { TextLoca } from "../text/TextLoca";
export var DialogWithItems = React.memo(function (_a) {
    var description = _a.description, itemsToDisplay = _a.itemsToDisplay, title = _a.title, onClose = _a.onClose, onConfirm = _a.onConfirm;
    return (React.createElement(DialogWrapper, { titleLocaId: title, onClose: onClose, className: IdStyles.ModalBackgroundBuyGold },
        React.createElement("div", { className: "flex flex--wrap flex--guts flex--stack h100 w100" },
            React.createElement(TextLoca, { id: description, className: IdStyles.TextBoldAccent }),
            React.createElement(RewardItems, { items: itemsToDisplay }),
            React.createElement(ButtonPrimary, { onClick: onConfirm },
                React.createElement(TextLoca, { id: IdLoca.confirm, className: IdStyles.TextButtonDefault })))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/dialog-with-items/DialogWithItems.tsx
// module id = 2963
// module chunks = 3